const HeroSwiper = props => {

};
export default HeroSwiper;
